import { ITimeoutService } from 'angular';
import UtilService from '../util.service';

/* @ngInject */
export default class GlobalSpinnerService {
  private activeCount = 0;
  private selfclose:boolean = false;

  constructor(
    private $timeout: ITimeoutService,
    private $rootScope: angular.IScope
  ) {}

  public start() {
    this.activeCount++;
  }

  public stop(selfclose?:boolean) {
    if(!selfclose && this.selfclose){
      return;
    }
    if(!!selfclose){
      this.selfclose = false;
    }
    this.$timeout(() => {
      if (this.activeCount > 0) {
        this.activeCount--;
        UtilService.applyIfNeeded(this.$rootScope);
      }
    });
  }

  public isActivated(): boolean {
    return this.activeCount > 0;
  }

  public startIfNotActivated(selfclose?:boolean) {
    if(selfclose){
      this.selfclose = true;
    }
    if(!this.isActivated()) {
        this.start();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/spinner/global-spinner.service.ts